import type { IdentityProps, UserProfileType } from '@3plearning/mx-teacher-analytics';

import { defaultLocale, locales } from '../locales/i18n';

export const IDENTITY_QUERY_PARAMS = {
    countryCode: 'countryCode',
    locale: 'locale',
    marketRegionId: 'marketRegionId',
    oneRosterUserId: 'oneRosterUserId',
    schoolId: 'schoolId',
    userProfileId: 'userProfileId',
    userProfileType: 'userProfileType'
} as const;

const mapUserProfileType = (type: string): UserProfileType => {
    switch (type) {
    case '2':
        return 'teacher';
    case '3':
        return 'admin';
    default:
        return 'unknown';
    }
};

const readParam = (queryParams: URLSearchParams, name: string): string => {
    const value = queryParams.get(name) ?? '';

    return value === 'null' || value === 'undefined' ? '' : value;
};

const resolveLocale = (locale: string): string => {
    const normalised = locale.replace('-', '_');

    return Object.values(locales).includes(normalised) ? normalised : defaultLocale;
};

export const buildIdentityProps = (queryParams: URLSearchParams): IdentityProps => ({
    locale: resolveLocale(readParam(queryParams, IDENTITY_QUERY_PARAMS.locale)),
    countryCode: readParam(queryParams, IDENTITY_QUERY_PARAMS.countryCode),
    userProfileId: readParam(queryParams, IDENTITY_QUERY_PARAMS.userProfileId),
    userProfileType: mapUserProfileType(readParam(queryParams, IDENTITY_QUERY_PARAMS.userProfileType)),
    marketRegionId: readParam(queryParams, IDENTITY_QUERY_PARAMS.marketRegionId),
    schoolId: readParam(queryParams, IDENTITY_QUERY_PARAMS.schoolId),
    oneRosterUserId: readParam(queryParams, IDENTITY_QUERY_PARAMS.oneRosterUserId)
});
